import * as Sentry from '@sentry/react';
import { APP_VERSION, APP_BRANCH, APP_COMMIT_SHA } from './version';

// Inicializa Sentry SE REACT_APP_SENTRY_DSN estiver setado no build.
// Sem DSN, vira no-op total — sem requests, sem overhead, sem deps
// ativadas. Ideal pra dev local (npm run start) e pra ambientes onde
// Sentry ainda nao foi provisionado.
//
// release: usa APP_VERSION pra cruzar com o que o sentry-cli upload de
// source maps espera. scripts/build.js no post-build roda
// `sentry-cli releases new higra-cco-front@$VERSION` quando
// SENTRY_AUTH_TOKEN esta configurado no CI — entao erros que chegarem
// do bundle ja vem symbolicados.
//
// environment: deriva da branch. main = production, hml = staging,
// resto (feat-x, dev) = development. Permite filtrar dashboard Sentry
// por ambiente.

export const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  const environment =
    APP_BRANCH === 'main'
      ? 'production'
      : APP_BRANCH === 'hml'
      ? 'staging'
      : 'development';

  Sentry.init({
    dsn,
    release: `higra-cco-front@${APP_VERSION}`,
    environment,
    // 10% das transacoes em prod, 100% em staging/dev. Permite usar
    // performance monitoring sem custo descontrolado em prod.
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // Filtro extra de seguranca: nao envia eventos quando rodando em
    // 'dev' (mesmo com DSN setado por engano).
    beforeSend(event) {
      if (APP_VERSION === 'dev') return null;
      return event;
    },
    // Anexa contexto util a todo evento. SHA + branch ajudam a
    // localizar o commit exato que gerou o erro.
    initialScope: {
      tags: {
        commit_sha: APP_COMMIT_SHA,
        branch: APP_BRANCH,
      },
    },
  });
};

// Re-exporta utilitarios comuns pra ficarem disponiveis via
// `from 'utils'` sem precisar conhecer o nome do pacote.
export const captureException = (error, context) => {
  if (!process.env.REACT_APP_SENTRY_DSN) return;
  Sentry.captureException(error, context);
};

export const captureMessage = (message, level = 'info') => {
  if (!process.env.REACT_APP_SENTRY_DSN) return;
  Sentry.captureMessage(message, level);
};
